import semver from 'semver';

export const isDocumentModelVersionTooHigh = (documentVersion: string, modelVersion: string): boolean => {
  const validDocumentVersion = semver.valid(documentVersion);
  const validModelVersion = semver.valid(modelVersion);

  return !!validDocumentVersion && !!validModelVersion && semver.gt(documentVersion, modelVersion);
};

export const isDocumentMigrationNeeded = (documentVersion: string, modelVersion: string): boolean => {
  const validDocumentVersion = semver.valid(documentVersion);
  const validModelVersion = semver.valid(modelVersion);

  return !!validDocumentVersion && !!validModelVersion && semver.lt(documentVersion, modelVersion);
};
